/* ============================================================
   Lumera mobile sort sheet
   Opens from the toolbar's Sort By button, applies on Apply only.
   Listeners are delegated so they survive the AJAX section swap.
   ============================================================ */
(function () {
    'use strict';

    function getDrawer() {
        return document.querySelector('[data-sort-drawer]');
    }

    function openDrawer() {
        var d = getDrawer();
        if (!d) return;
        d.setAttribute('data-open', '');
        d.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
        var d = getDrawer();
        if (!d) return;
        d.removeAttribute('data-open');
        d.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
    }

    /* Build the sort URL from the current address so active filters are kept.
       Page is dropped, because a new sort order starts from page one. */
    function buildSortUrl(value) {
        var u = new URL(window.location.href);
        u.searchParams.delete('page');
        if (value) {
            u.searchParams.set('sort_by', value);
        } else {
            u.searchParams.delete('sort_by');
        }
        return u.pathname + u.search;
    }

    document.addEventListener('click', function (e) {
        if (e.target.closest('[data-sort-open]')) { openDrawer(); return; }
        if (e.target.closest('[data-sort-close]')) { closeDrawer(); return; }

        var option = e.target.closest('[data-sort-option]');
        if (option) {
            var drawer = getDrawer();
            if (!drawer) return;
            drawer.querySelectorAll('[data-sort-option]').forEach(function (o) {
                var selected = o === option;
                o.classList.toggle('is-selected', selected);
                o.setAttribute('aria-checked', selected ? 'true' : 'false');
            });
            return;
        }

        if (e.target.closest('[data-sort-apply]')) {
            var d = getDrawer();
            if (!d) return;
            var selectedOption = d.querySelector('[data-sort-option].is-selected');
            var value = selectedOption ? selectedOption.getAttribute('data-sort-value') : '';
            var url = buildSortUrl(value);

            closeDrawer();

            if (typeof window.lumApplyFilterUrl === 'function') {
                window.lumApplyFilterUrl(url);
            } else {
                window.location.href = url;
            }
        }
    });

    document.addEventListener('keydown', function (e) {
        var d = getDrawer();
        if (e.key === 'Escape' && d && d.hasAttribute('data-open')) closeDrawer();
    });
})();